// extracted by mini-css-extract-plugin
module.exports = {"container":"d","footer":"e","footerBorder":"f","footerMainContainer":"g"};